import Cookies from "js-cookie";
import axios from "axios";
import { useMutation } from "react-query";
import { serverBaseUrl } from "../config/envs";

const edit = async (token = null, postData) => {
  try {
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await axios.put(
      `${serverBaseUrl}/edit_template_field`,
      postData,
      { headers }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      const { status, data } = error.response;

      if (status === 400 || status === 500) {
        return data;
      }

      throw new Error(data?.message || "Request failed");
    }
    throw error;
  }
};

export const useUpdateTemplateFieldsMutation = () => {
  const token = Cookies.get("token");

  return useMutation(["edit_template_field", token], (postData) =>
    edit(token, postData)
  );
};
